enum ActFunc {
	Sigmoid = "SIGMOID",
	Relu = "RELU",
	Identity = "IDENTITY"
}

export default ActFunc;